import { Col, Row, Layout, Input, Select, DatePicker, Tabs } from 'antd'
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react'

import OrderTab from "./OrderTab";
import PortfolioTab from './PortfolioTab';
const { TabPane } = Tabs;

var box = {
    minHeight: 100,
    backgroundColor: "white",
    margin: 10,
    padding: 30,
    borderRadius: 10
};
const { Option } = Select;

const Portfolio = observer(({ props }) => {
    return (
        <>
            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                <Col span={24}>
                    <div style={box}>
                        <Tabs defaultActiveKey="1"  >
                            <TabPane tab="Wish" key="1"> <PortfolioTab /></TabPane>
                        </Tabs>
                    </div>
                </Col>

            </Row>
        </>
    );
});
export default Portfolio;